import React, { useState, useEffect } from 'react'
import './styles.scss'
import { Link, useParams } from 'react-router-dom'
import productData from 'services/getProducts'
import { numberWithCommas } from 'utils/priceConvert'
import { useCartContext } from 'context/shop/CartProvider'
import NotFound from 'components/NotFound'
import ModalSuccess from 'components/Modal'
import ProductRelated from 'features/Shop/components/ProductRelated'
import Button from 'components/Button'
import sizeChart_1 from 'assets/shop/size_chart_1.png'
import sizeChart_2 from 'assets/shop/size_chart_2.png'
function ShopDetails() {
  const { slug } = useParams()
  const { addItem } = useCartContext()

  const [product, setProduct] = useState(null)
  const [currentImg, setCurrentImg] = useState(null)
  const [selectedImage, setSelectedImage] = useState(null)
  const [size, setSize] = useState(null)

  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    // Fetch product data by slug when the component mounts
    const fetchProductData = async () => {
      try {
        const fetchedProduct = await productData.getProductBySlug(slug)
        setProduct(fetchedProduct)
        setCurrentImg(fetchedProduct.listImage[0])
        setSelectedImage(fetchedProduct.listImage[0])
        setSize(fetchedProduct.size[0])
      } catch (error) {
        console.error('Error fetching product data:', error)
      }
    }

    fetchProductData()

    const windowWidth = window.innerWidth
    if (windowWidth >= 1340) {
      window.scrollTo(0, 0)
    } else if (windowWidth >= 750) {
      window.scrollTo(0, 0)
    } else {
      window.scrollTo(0, 0)
    }
  }, [slug])

  if (!product) {
    return <NotFound />
  }

  const handleImageClick = (item) => {
    setCurrentImg(item)
    setSelectedImage(item)
  }

  // function handle add item to cart
  const handleAddToCard = () => {
    const productToAdd = {
      slug: product.slug,
      image: product.image01,
      name: product.title,
      price: product.price,
      size: size,
      quantity: 1
    }
    addItem(productToAdd)
    setShowModal(true)
  }

  // function handle image view
  const handleSizeClick = (item) => {
    setSize(item)
  }

  return (
    <div className="shop-details">
      <div
        className={`modal-overlay ${showModal ? '' : 'hidden'}`}
        onClick={() => setShowModal(false)} // Close the modal when clicking outside
      >
        <div className="modal-content">
          <ModalSuccess>Add to cart success</ModalSuccess>
        </div>
      </div>

      <div className="shop-details-top">
        <div className="shop-details-left">
          <div className="tag-detail">
            <p className="text">New arrival</p>
          </div>
          <div className="shop-main-image">
            <img src={currentImg} alt={product.title} />
          </div>

          <div className="shop-image-list">
            {product.listImage.map((item, index) => (
              <div
                key={index}
                className={`shop-image-list-item ${selectedImage === item ? 'selected-image' : ''}`}
              >
                <img src={item} alt={`images${index + 1}`} onClick={() => handleImageClick(item)} />
              </div>
            ))}
          </div>
        </div>
        <div className="shop-details-right">
          <h1 className="shop-details-right-title">{product.title}</h1>

          <span className="shop-details-right-price">${numberWithCommas(product.price, 2)}</span>

          <div className="shop-details-size">
            {product.size.map((item, index) => (
              <div
                key={index}
                className={`size-item ${size === item ? 'clicked-size' : ''}`}
                onClick={() => handleSizeClick(item)}
              >
                <p>
                  Size<span className="size-prefix"> {item}</span>
                </p>
              </div>
            ))}
          </div>
          <div className="shop-details-button">
            <Button size="sm" borderRadius="detail" fontSize="h5" onClick={handleAddToCard}>
              Add to cart
            </Button>
            <Link to={'/checkout'}>
              <Button
                onClick={handleAddToCard}
                size="sm"
                color="btn-color"
                backgroundColor="custom"
                borderRadius="detail"
                fontSize="h5"
              >
                Buy now
              </Button>
            </Link>
          </div>

          <div className="shop-details-decriptions">
            <span className="title">Description:</span>
            <div className="frame-detail-description">
              <p className="content">Quality: {product.description.title}</p>
              <p className="content">Size: {product.description.quality}</p>
              <p className="content">{product.description.size}</p>
              <p className="content">Color: {product.description.color}</p>
            </div>
          </div>
          <div className="shop-details-size-chart">
            <span className="title">Size Chart:</span>
            <div className="size-chart-img">
              <img src={sizeChart_2} alt="sizechart_2" />
              <img className="size-chart-1" src={sizeChart_1} alt="sizechart_1" />
            </div>
          </div>
        </div>
      </div>
      <ProductRelated />
    </div>
  )
}

export default ShopDetails
